import { createSlice } from '@reduxjs/toolkit';
export interface DataState {
  data: any;
  formData: any;
  dates: any;
  versionEffectiveDate: any;
  versionEndDate: any;
  nextExpCtDate: any;
  earlyDate:any;
  gpsForm:any,
  formState:any;
  submitterData:any;
  versions:any;
  isToggled:boolean;
}
const initialState: DataState = {
  data: [],
  formData: [],
  submitterData:[],
  gpsForm:[],
  dates: [],
  versionEndDate: null,
  versionEffectiveDate:null,
  nextExpCtDate: null,
  earlyDate:null,
  formState:[],
  versions:[],
  isToggled:false
};

export const ListofValuesSlice = createSlice({
  name: 'fetchProfileList',
  initialState,
  reducers: {
   setLovData: (state, action) => {
      state.data = action.payload;
    },
    setFormData: (state, action) => {
      state.gpsForm = action.payload;
    },
    updateFormData: (state, action) => {
      state.gpsForm = action.payload;
    },
    setForm: (state, action) => {
      state.formData = action.payload;
    },
    setSubmitterdata: (state, action) => {
      state.submitterData = action.payload;
    },
    setGpsForm: (state, action) => {
      state.gpsForm = action.payload;
    },

    SetVerEndDate: (state, action) => {
      state.versionEndDate = action.payload;
    },
    setEarlyExpdDate: (state, action) => {
      state.earlyDate = action.payload;
    },
    setVerStartDate: (state, action) => {
      state.versionEffectiveDate = action.payload;
    },
    setNextFileIndicator: (state, action) => {
      state.nextExpCtDate = action.payload;
    },
    setFormState: (state, action) => {
      state.formState = action.payload;
    },
    setVesrionData: (state, action) => {
      state.versions = action.payload;
    },
    toggle: (state) => {
      state.isToggled = !state.isToggled;
    },
  },
});
export const { toggle,setLovData, setForm,setSubmitterdata, setVerStartDate, SetVerEndDate,setNextFileIndicator,setGpsForm,setFormState,setEarlyExpdDate,setFormData,updateFormData,setVesrionData } =
  ListofValuesSlice.actions;
export default ListofValuesSlice.reducer;
